import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, InputGroup } from "react-bootstrap";
import {
  sendOtp,
  verifyOtp,
  completeSignup,
  login,
} from "../services/authService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const LoginModal = ({
  show,
  handleClose,
  openSignupModal,
  closeLoginModal,
}) => {
  const navigate = useNavigate();

  const [isOtpLogin, setIsOtpLogin] = useState(true);

  // OTP login
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [isNewUser, setIsNewUser] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [existingUserName, setExistingUserName] = useState("");

  // Password login
  const [loginPhone, setLoginPhone] = useState("");
  const [loginPassword, setLoginPassword] = useState("");

  const handleSendOtp = async (e) => {
    e.preventDefault();
    try {
      await sendOtp("+91" + phone);
      toast.success("OTP sent!");
      setOtpSent(true);

      if ("OTPCredential" in window) {
        const ac = new AbortController();
        navigator.credentials
          .get({ otp: { transport: ["sms"] }, signal: ac.signal })
          .then((otpCred) => {
            setOtp(otpCred.code);
            handleVerifyOtp(null, otpCred.code);
          })
          .catch((err) => console.log("OTP auto-detect error:", err));
      }
    } catch (err) {
      toast.error("Failed to send OTP.");
    }
  };

  const handleVerifyOtp = async (e, code = otp) => {
    if (e) e.preventDefault();
    try {
      const res = await verifyOtp("+91" + phone, code);
      const data = res.data;

      if (data.isNewUser) {
        setIsNewUser(true);
        toast.info("Please complete registration.");
        setExistingUserName("");
      } else {
        setIsNewUser(false);
        setExistingUserName(data.name);
        localStorage.setItem("user", JSON.stringify(data.user)); // ✅ Store user
        toast.success(`Welcome back, ${data.name}!`);
        handleClose();
        // Optional: navigate("/") if you want redirection
      }
    } catch (err) {
      toast.error("Invalid OTP.");
    }
  };

  const handleCompleteSignup = async (e) => {
    e.preventDefault();
    try {
      await completeSignup({ phone: "+91" + phone, name, email });
      toast.success("Signup complete. Logged in!");
      handleClose();
    } catch (err) {
      toast.error("Signup failed.");
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await login(loginPhone, loginPassword);
      toast.success("Login successful!");
      handleClose();
    } catch (err) {
      toast.error("Login failed. Check credentials.");
    }
  };

  const handleToggle = () => {
    setIsOtpLogin(!isOtpLogin);
    setPhone("");
    setOtp("");
    setOtpSent(false);
    setIsNewUser(false);
    setName("");
    setEmail("");
    setLoginPhone("");
    setLoginPassword("");
    setExistingUserName("");
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton className="border-0">
        <Modal.Title className="w-100 text-center fw-bold">
          {isOtpLogin ? "Login with Phone OTP" : "Login with Phone & Password"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4">
        <div className="text-center mb-3">
          <Button variant="outline-secondary" onClick={handleToggle}>
            {isOtpLogin ? "Use Phone & Password" : "Use OTP Instead"}
          </Button>
        </div>

        {isOtpLogin ? (
          <Form
            onSubmit={
              isNewUser
                ? handleCompleteSignup
                : otpSent
                ? handleVerifyOtp
                : handleSendOtp
            }
          >
            <Form.Group controlId="phone" className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <InputGroup>
                <InputGroup.Text>+91</InputGroup.Text>
                <Form.Control
                  type="tel"
                  placeholder="Enter 10-digit phone number"
                  value={phone}
                  onChange={(e) => {
                    const val = e.target.value;
                    if (/^\d{0,10}$/.test(val)) setPhone(val);
                  }}
                  required
                  disabled={otpSent || isNewUser}
                />
              </InputGroup>
            </Form.Group>

            {otpSent && !isNewUser && (
              <Form.Group controlId="otp" className="mb-3">
                <Form.Label>Enter OTP</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="6-digit OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  required
                />
              </Form.Group>
            )}

            {isNewUser && (
              <>
                <Form.Group controlId="name" className="mb-3">
                  <Form.Label>Your Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter your name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                  />
                </Form.Group>
                <Form.Group controlId="email" className="mb-3">
                  <Form.Label>Email (optional)</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Enter email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Form.Group>
              </>
            )}

            {existingUserName && (
              <div className="text-center mb-3">
                <strong>Welcome back, {existingUserName}!</strong>
              </div>
            )}

            <Button
              type="submit"
              className="w-100 my-3"
              style={{ backgroundColor: "#FFA500", borderColor: "#FFA500" }}
            >
              {isNewUser
                ? "COMPLETE SIGNUP"
                : otpSent
                ? "VERIFY OTP"
                : "SEND OTP"}
            </Button>
          </Form>
        ) : (
          <Form onSubmit={handleLogin}>
            <Row className="mb-3">
              <Col md={6}>
                <Form.Group controlId="loginPhone">
                  <Form.Label>Phone Number</Form.Label>
                  <InputGroup>
                    <InputGroup.Text>+91</InputGroup.Text>
                    <Form.Control
                      type="tel"
                      placeholder="Enter 10-digit phone number"
                      value={loginPhone}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d{0,10}$/.test(val)) setLoginPhone(val);
                      }}
                      required
                    />
                  </InputGroup>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="loginPassword">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Enter password"
                    value={loginPassword}
                    onChange={(e) => setLoginPassword(e.target.value)}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Button
              type="submit"
              className="w-100 my-3"
              style={{ backgroundColor: "#FFA500", borderColor: "#FFA500" }}
            >
              SIGN IN
            </Button>

            <div className="d-flex justify-content-end mb-2">
              <a
                href="#!"
                className="text-decoration-none small text-dark fw-bold"
              >
                Forget Password?
              </a>
            </div>
          </Form>
        )}
      </Modal.Body>

      <div className="px-4 pb-4 text-center">
        <hr />
        <div className="fw-bold">DO NOT HAVE AN ACCOUNT?</div>
        <button
          onClick={() => {
            closeLoginModal();
            openSignupModal();
          }}
          className="btn btn-link text-decoration-none fw-bold"
          style={{ color: "#FFA500" }}
        >
          CREATE AN ACCOUNT
        </button>
      </div>
    </Modal>
  );
};

export default LoginModal;
